import { defineStore } from 'pinia'
import { useStorageRef } from '@elecmap/shared/src/composable/use-storage-ref'
import { computed } from 'vue'
import type { ResponseData } from '../../../api/src/ram.d'
import { logout as doLogout, getEmployeeOrganizationRole, queryLoginInfo } from '@elecmap/api/src/ram'
import { useSpaceStore } from './space'

const userStore = defineStore('userStore', () => {
  const userInfo = useStorageRef('userInfo')
  const showInitialModal = useStorageRef('showInitialModal', false)
  const isPlatformUser = computed(() => userInfo.value?.organizationType === 'platform')
  const notPersonal = computed(() => userInfo.value?.organizationType !== 'personal')

  const isLogin = computed(() => !!userInfo.value?.userId)
  function setUser(data: any) {
    userInfo.value = data
    localStorage.setItem('userInfo', JSON.stringify(data))
    useSpaceStore().navs = []
    tryGetRole()
  }

  function refreshUserInfo() {
    queryLoginInfo().then(setUser)
  }

  function tryGetRole() {
    if (userInfo.value?.userId) {
      getEmployeeOrganizationRole({ userId: userInfo.value.userId }).then(data => {
        userInfo.value.role = data.role
        userInfo.value.roleName = data.roleName
      })
    }
  }

  tryGetRole()

  function deleteUser() {
    setUser({} as ResponseData)
  }

  async function logout() {
    await doLogout({ token: userInfo.value!.token! })
    deleteUser()
    const space = useSpaceStore()
    space.navs = []
    return
  }

  return {
    userInfo,
    isLogin,
    showInitialModal,
    refreshUserInfo,
    setUser,
    deleteUser,
    logout,
    tryGetRole,
    isViewAccount: computed(() => userInfo.value?.employeeSeatType === 'view'),
    isPersonalOrg: computed(() => userInfo.value?.organizationType === 'personal'),
    canManage: computed(() => ['owner', 'manager'].includes(userInfo.value?.role)),
    isPlatformUser,
    notPersonal,
    organizationId: computed(() => userInfo.value?.organizationId),
    userKey: computed(() => {
      if (!userInfo.value) return undefined
      return `key${userInfo.value.userId}${userInfo.value.organizationId}`
    }),
  }
})

export default userStore
